module.exports = __webpack_public_path__ + "static/media/trip.6005ec4b.png";